import { createFileRoute, Link } from "@tanstack/react-router";
import { CaixaDetalhePage } from "@/pages/CaixaDetalhePage";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/caixas/$id")({
  head: () => ({ meta: [{ title: "Detalhe da Caixa — AXIS Comprovantes" }] }),
  component: () => (
    <div className="space-y-4">
      <Button variant="ghost" size="sm" asChild className="-ml-2">
        <Link to="/caixas" className="gap-2">
          <ArrowLeft className="h-4 w-4" /> Voltar para Caixas
        </Link>
      </Button>
      <CaixaDetalhePage />
    </div>
  ),
});
